import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { TextField } from 'src/Libs/inputs/formik'

/**
 * Page with input field for vehicle identification number
 */
const VehicleIdentificationNumberPage: React.VFC = () => {
  const { t } = useCustomTranslation()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 2 }}>
      <Typography variant="h3">{t('emobility.vendor-connection-terms-dialog.vin-page-title')}</Typography>
      <Typography variant="body1">{t('emobility.vendor-connection-terms-dialog.vin-page-content')}</Typography>
      <TextField name="vin" label={t('emobility.vendor-connection-terms-dialog.vin')} />
    </Box>
  )
}

export default VehicleIdentificationNumberPage
